import { Stack } from "@fluentui/react";
import { useEffect, useState } from "react";
import '../styles/superadmin.css';
import StatusComponent from "./statusComponent";
import Logs from "./logsComponent";
import cookie from 'react-cookies';
import SSH from "./sshComponent";
import SqlComponent from "./sqlComponent";

export interface ISuperAdminProps {
}

const SuperAdmin: React.FunctionComponent<ISuperAdminProps> = (props: ISuperAdminProps) => {
    const [openMenuID, setOpenMenuID ] = useState<number>();
    const [site, setsite] = useState<string>("");
    const [username, setusername] = useState<string>("");
    const [token, settoken] = useState<string>("");
    const [apiurl, setapiurl] = useState<string>(document.location.origin + "/Backend");

    const menuItems1 = [{id:0, label:"Site toevoegen"},{id:1, label:"Admin password reset"}];
    const menuItems2 = [{id:2, label:"SSH"},{id:3, label:"journalctr"}, {id:4, label:"Script logs"}];
    const menuItems3 = [{id:5, label:"SQL"}];

    const menuItems = [menuItems1, menuItems2, menuItems3];

    useEffect(() => {
        const [_site, _username, _token] = getSiteUsernameToken();
        setsite(_site);
        setusername(_username);
        settoken(_token);
        CheckLoginStatus();
    }, []);

    function getSiteUsernameToken() : string[] {
        let selectedSite = "";
        if (document.location.host === "localhost:3000") {
            selectedSite = "retrocollectie";
        } else {
            const locparts = document.location.host.split('.');
            if (locparts[0].toLowerCase() === "admin") {
                selectedSite = locparts[1];
            } else {
                selectedSite = locparts[0].substring(5) + "." + locparts[1];
            }
        }

        return [selectedSite, cookie.load('username') as string, cookie.load('token') as string];
    }

    function CheckLoginStatus() {
        const [s,u,t] = getSiteUsernameToken();
        fetch(`${apiurl}/IsLoggedIn?site=${s}&username=${u}&token=${t}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => {
            if (data.success !== true) {
                GoHome();
            }
        }).catch(err => {
            GoHome();    
        });
        
        setTimeout(() => {
            CheckLoginStatus();
        }, 10000);
    }

    function GoHome() {
        window.location.replace(window.location.origin);
    }

    return (
        <Stack horizontalAlign="start" verticalAlign="start" style={{height:"100%", width: "100%", margin: 5, padding: 10 }}>
            <Stack horizontal>
                {menuItems.map((item) => (
                    <ul>
                        {item.map((i) => (
                            <li key={i.id} onClick={() => {setOpenMenuID(i.id);}} className={i.id === openMenuID ? "liselected" : ""}>
                                <span>{i.label}</span>
                            </li>
                        ))}
                    </ul>
                ))}
            </Stack>
            {
            
            openMenuID === 0 ?
                <>
                </>
            : openMenuID === 1 ? 
                <>
                </>
            : openMenuID === 2 ? 
                <>
                    <SSH apiUrl={apiurl} username={username} token={token} site={site} />
                </>
            : openMenuID === 3 ? 
                <>
                    <StatusComponent dev={false} apiUrl={apiurl} username={username} token={token} site={site} />
                </>
            : openMenuID === 4 ? 
                <>
                    <Logs dev={false} apiUrl={apiurl} username={username} token={token} site={site} />
                </>
            : openMenuID === 5 ? 
                <>
                    <SqlComponent apiUrl={apiurl} />
                </>    
            : <>
              </>
            }
        </Stack>
    );
}

export default SuperAdmin;